import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=9484ba74&"
import script from "./SelectBox.vue?vue&type=script&lang=js&"
export * from "./SelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports